import React, { useState, useEffect } from "react";
import "../styles/HeroSlider.scss";

const HeroSlider = ({ banners = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-slide every 3 seconds
  useEffect(() => {
    if (banners.length === 0) return;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % banners.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [banners]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const goNext = () => {
    setCurrentIndex((prev) => (prev + 1) % banners.length);
  };

  const goPrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? banners.length - 1 : prev - 1
    );
  };

  if (!banners || banners.length === 0) return null;

  return (
    <section className="hero-slider-section">
      <div className="slider-container">
        <div
          className="slides"
          style={{
            transform: `translateX(-${currentIndex * 100}%)`,
          }}
        >
          {banners && banners.map((item, idx) => (
            <div className="slide" key={idx}>
              {item.link ? (
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={item.banner}
                    alt={`slide-${idx}`}
                    className="slide-img"
                  />
                </a>
              ) : (
                <img
                  src={item.banner}
                  alt={`slide-${idx}`}
                  className="slide-img"
                />
              )}
            </div>
          ))}
        </div>

        {/* Navigation buttons */}
        <button className="prev-btn" onClick={goPrev}>
          ❮
        </button>
        <button className="next-btn" onClick={goNext}>
          ❯
        </button>

        {/* Pagination Dots */}
        <div className="dots">
          {banners && banners.map((_, idx) => (
            <span
              key={idx}
              className={`dot ${idx === currentIndex ? "active" : ""}`}
              onClick={() => goToSlide(idx)}
            ></span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSlider;
